
import React, { useState } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Form, Card, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';

function General_Master() {

  const [optionType, setOptionType] = useState('DESIG');

  // const [hdnirn, setHdnIRN] = useState('');  
  // const [txtcommonTypeDesc, setTxtCommonTypeDesc] = useState('');
  // const [ddlcommType, setDdlCommType] = useState('');

  // Header State
  const [headerData, setHeaderData] = useState({
    gen_id: '',
    type_desc: '',
    description: '',
    short_desc: '',
    flag: '',
    mand_opt: '',
    status: '',
  });

  const [rdcommontype, setRDCommonType] = useState('State');
  const [comm_masterData, setComm_MasterData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);

  const [childRows, setChildRows] = useState([
    {
      gen_id: '',
      type_desc: '',
      description: '',
      short_desc: '',
      flag: '',
      mand_opt: '',
      status: '',
    }
  ]);
  const handleRowClick = async (irn, comm_type_desc, comm_type) => {
    try {

      var lv_Type = '';

      if (comm_type_desc === 'Emp Designation') {
        lv_Type = 'DESIG';
      }
      else if (comm_type_desc === 'Category') {
        lv_Type = 'CATG';
      }
      else if (comm_type_desc === 'Leaves Master') {
        lv_Type = 'LEAVES';
      }
      else if (comm_type_desc === 'Earning Components') {
        lv_Type = 'EARN_COMP';
      }
      else if (comm_type_desc === 'Deduction Components') {
        lv_Type = 'DEDUCT_COMP';
      }

      // setHdnIRN(irn);
      // setTxtCommonTypeDesc(comm_type_desc);
      // setDdlCommType(comm_type);
      setIsEditable(true);

    } catch (error) {
      console.error('Error fetching Level 3 group data:', error);
    }
  };

  
  const handleClear = () => {
    if (!window.confirm("Clear form?")) return;
    headerData.description = '';
    headerData. gen_id = '';
    headerData.type_desc = '';
    headerData.flag = '';
    headerData.mand_opt = '';
    headerData.status = '';
    setIsEditable(false);
    
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };


  const handleNewRow = () => {

    // setHdnIRN('');
    // setDdlCommType('0');
    // setTxtCommonTypeDesc('');
    setIsEditable(true);

  };
  

  const handleTypeRadioButton = async (e) => {

    const lv_selected_val = e.target.value;

    setRDCommonType(lv_selected_val);
    var lv_Type = '';

    if (lv_selected_val === 'Designation') {
      lv_Type = 'DESIG';
      setOptionType('DESIG');
    }
    else if (lv_selected_val === 'Category') {
      lv_Type = 'CATG';
      setOptionType('CATG');
    }
    else if (lv_selected_val === 'Leaves Master') {
      lv_Type = 'LEAVES';
      setOptionType('LEAVES');
    }
    else if (lv_selected_val === 'Earning Components') {
      lv_Type = 'EARN_COMP';
      setOptionType('EARN_COMP');
    }
    else if (lv_selected_val === 'Deduction Components') {
      lv_Type = 'DEDUCT_COMP';
      setOptionType('DEDUCT_COMP');
    }

    console.log('lv_selected_val ===> ', lv_selected_val);
    console.log('lv_Type ===> ', lv_Type);

    setComm_MasterData([]);

    /// Temporarily commted by Anis
    //    const response = await axios.get(`${BASE_URL}/api/get_mst_common_typewise`, {params : {p_type: lv_Type }});
    // if (response.data.length > 0) {  
    //   setComm_MasterData(response.data);
    // }

  };

  const handleSave = async () => {

    // if (!txtcommonTypeDesc) {
    //   alert("Please enter Common Type Description !");
    //   return;
    // }
    // else if (ddlcommType === '0') {
    //   alert("Please select Common Type !");
    //   return;
    // }

    try {
      // Adjust the API endpoint and method based on your backend
      // const payload = {
      //   irn: hdnirn,
      //   commonType: ddlcommType,
      //   commonTypeDesc: txtcommonTypeDesc,
      // };

      // await axios.post(`${BASE_URL}/api/save_common_master`, payload);

      alert("Saved successfully!");


      // Disable editing after save
      // setIsEditable(false);
      // setHdnIRN('');
      // setTxtCommonTypeDesc('');
      // setDdlCommType('0');

    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save Common Master.", error);
    }

  };

  return (
    <Container fluid className="p-3">

      <Card style={{ marginTop: '10px', padding: '6px' }}>

        <Row className="mb-3"></Row>
        <Row className="mb-3">
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "200px" }}>
                {optionType === 'DESIG' ? 'Designation Name' :
                  optionType === 'CATG' ? 'Category Name' :
                    optionType === 'LEAVES' ? 'Leaves Name' :
                      optionType === 'EARN_COMP' ? 'Earning Components' : 'Deduction Components'
                }
              </InputGroup.Text>
              <Form.Control
                type="text"
                name="description"
                value={headerData.description}
                onChange={handleChange}
                // onChange={handleHeaderChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}>
                Status
              </InputGroup.Text>
              <Form.Select
                name="status"
                value={headerData.status}
                // onChange={handleHeaderChange}
                disabled={!isEditable}
              >
                <option value="">Select Status</option>
                <option value="A">Active</option>
                <option value="I">Inactive</option>
              </Form.Select>
            </InputGroup>
          </Col>
        </Row>

        {optionType === 'LEAVES' &&
          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "200px" }}>
                  Leave Short Name
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  name="description"
                  value={headerData.description}
                  onChange={handleChange}
                  // onChange={handleHeaderChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "130px" }}>
                  Leave Type
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="CF">Carry Forward</option>
                  <option value="L">Lapse</option>
                  <option value="COMPOFF">Compensatory</option>
                </select>
              </InputGroup>
            </Col>
          </Row>
        }
        {optionType === 'EARN_COMP' &&
          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                  Component Type
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="DC">Deductable Component</option>
                  <option value="NDC">Non-Deductable Component</option>
                </select>
              </InputGroup>
            </Col>

             <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                  Mandatory/Optional
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="MAND"> Mandatory</option>
                  <option value="OPT">Optional</option>
                </select>
              </InputGroup>
            </Col>          
          </Row>
        }

        {optionType === 'DEDUCT_COMP' &&
          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                  Component Type
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="O">Others</option>
                  <option value="PF">Provident Fund</option>
                  <option value="IT">Income Tax </option>
                  <option value="PT">Professional Tax</option>

                </select>
              </InputGroup>
            </Col>

             <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                  Mandatory/Optional
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="MAND">Mandatory</option>
                  <option value="OPT">Optional</option>
                </select>
              </InputGroup>
            </Col>
          </Row>
        }

        <Row className="mb-3">
          <Col className="ms-auto d-flex justify-content-end gap-2">

            <button
              className="btn btn-primary"
              style={{ width: "135px" }}
              disabled={isEditable}
              onClick={handleNewRow}
            >
              New
            </button>

            <button
              className="btn btn-secondary"
              style={{ width: "135px" }}
              onClick={handleClear}
            >
              Clear
            </button>

            <button
              className="btn btn-success"
              style={{ width: "135px" }}
              onClick={handleSave}
              disabled={!isEditable}
            >
              Save
            </button>

          </Col>
        </Row>




      </Card>

      <Card style={{ marginTop: '10px', padding: '10px' }}>

        <Row className="mb-3">
          <Col md={8} className="d-flex align-items-center">
            <label className="label-color-common form-label fw-bold">Type :</label> &nbsp;&nbsp;
            <div className="d-flex flex-wrap gap-2">
              {['Designation', 'Category', 'Leaves Master', 'Earning Components', 'Deduction Components'].map((option) => (
                <Form.Check inline key={option} type="radio" label={option} name="rdcommontype"
                  value={option} checked={rdcommontype === option} onChange={handleTypeRadioButton} />
              ))}
            </div>
          </Col>
        </Row>

        <div className="table-wrapper">
          {/******************************************************************/}
          {/**********************  Designation Start ************************/}
          { /******************************************************************/}
          {optionType === 'DESIG' &&
            <table className="responsive-table">
              {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Designation Name</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="2" style={{ textAlign: 'center' }}>No Designation Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onChange={handleChange}onClick={() => handleRowClick(item.irn, item.comm_type_desc, item.comm_type)}
                      style={{ cursor: 'pointer', height: '40px' }}>
                      <td style={{ display: 'none' }}>{item.irn}</td>
                      <td>{item.comm_type_desc}</td>
                      <td>{item.comm_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          }
          {/******************************************************************/}
          {/**********************  Designation End **************************/}
          {/******************************************************************/}

          {/******************************************************************/}
          {/**********************  Category Start  **************************/}
          {/******************************************************************/}
          {optionType === 'CATG' &&
            <table className="responsive-table">
              {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Category Name</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="2" style={{ textAlign: 'center' }}>No Category Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onClick={() => handleRowClick(item.irn, item.comm_type_desc, item.comm_type)}
                      style={{ cursor: 'pointer', height: '40px' }}>
                      <td style={{ display: 'none' }}>{item.irn}</td>
                      <td>{item.comm_type_desc}</td>
                      <td>{item.comm_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          }
          {/******************************************************************/}
          {/**********************  Category End ****************************/}
          {/******************************************************************/}

          {/******************************************************************/}
          {/**********************  Leaves Master ****************************/}
          {/******************************************************************/}

          {optionType === 'LEAVES' &&
            <table className="responsive-table">
              {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Leave Name</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Leave Short Name</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Leave Type</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center' }}>No Leaves Master Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onClick={() => handleRowClick(item.irn, item.comm_type_desc, item.comm_type)}
                      style={{ cursor: 'pointer', height: '40px' }}>
                      <td style={{ display: 'none' }}>{item.irn}</td>
                      <td>{item.comm_type_desc}</td>
                      <td>{item.comm_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          }
          {/***********************************************************************/}
          {/**********************  Earning Start **************************/}
          {/***********************************************************************/}

          {optionType === 'EARN_COMP' &&
            <table className="responsive-table">
              {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Earning Components</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Component Type</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>	Mandatory/Optional</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center' }}>No Earning Components  Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onClick={() => handleRowClick(item.irn, item.comm_type_desc, item.comm_type)}
                      style={{ cursor: 'pointer', height: '40px' }}>
                      <td style={{ display: 'none' }}>{item.irn}</td>
                      <td>{item.comm_type_desc}</td>
                      <td>{item.comm_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          }
          {/***********************************************************************/}
          {/**********************  Deduction Start **************************/}
          {/***********************************************************************/}

          {optionType === 'DEDUCT_COMP' &&
            <table className="responsive-table">
              {/* style={{ width: '800px', height: '100%', minHeight: '100px' }}> */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', display: 'none' }}>irn</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '400px' }}>Deduction Component</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Component Type</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Mandatory/Optiona</th>
                  <th style={{ textAlign: 'left', background: 'lightblue', color: 'black', width: '200px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {comm_masterData.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center' }}>No Deduction Found</td>
                  </tr>
                ) : (
                  comm_masterData.map((item, index) => (
                    <tr key={index} onClick={() => handleRowClick(item.irn, item.comm_type_desc, item.comm_type)}
                      style={{ cursor: 'pointer', height: '40px' }}>
                      <td style={{ display: 'none' }}>{item.irn}</td>
                      <td>{item.comm_type_desc}</td>
                      <td>{item.comm_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          }

          {/******************************************************************/}
          {/*********************  Deduction End  ***************************/}
          {/******************************************************************/}




        </div>
      </Card>
    </Container>
  )
}
export default General_Master;



